@if (isAvailable) {
<div class="fx-row fx-align-center tile-controls" [class.hidden]="isHidden">
  <div>
    @if (isMenuTriggerVisible) {
    <button
      [attr.aria-label]="
        (isMenuOpen() ? 'Close' : 'Open') + ' participant options' | translate
      "
      avButton
      #menuButton
      size="xxs"
      ofType="icon"
      [color]="isMenuOpen() ? 'basic' : 'primary'"
      (click)="toggleMenu()"
      (keydown)="jumpInMenu($event)"
      class="tile-control-trigger"
      data-tid="tile-controls/open-menu"
    >
      @if (isMenuOpen()) {
      <av-icon mode="dark" name="close-big"></av-icon>
      } @if (!isMenuOpen()) {
      <av-icon mode="light" name="more-vertical"></av-icon>
      }
    </button>
    }
  </div>
  @if (isSnapshotActive) {
  <button
    class="tile-tool-light"
    avButton
    [attr.aria-label]="'Stop taking snapshots' | translate"
    ofType="stroked"
    size="xxs"
    (click)="snapshotTerminate()"
    [themable]="false"
    translate
    data-tid="tile-controls/stop-snapshots"
  >
    Stop snapshots
  </button>
  } @if (isLaserActive) {
  <button
    class="tile-tool-light"
    avButton
    [attr.aria-label]="'Stop AR pointer' | translate"
    ofType="stroked"
    size="xxs"
    (click)="togglePointer()"
    [themable]="false"
    translate
    data-tid="tile-controls/stop-ar-pointer"
  >
    Stop AR pointer
  </button>
  } @if (isCobrowseActive) {
  <button
    class="tile-tool-light"
    [disabled]="isCobrowseStopDisabled"
    avButton
    [attr.aria-label]="'Stop co-browsing' | translate"
    ofType="stroked"
    size="xxs"
    [themable]="false"
    (click)="cobrowseTerminate()"
    translate
    data-tid="tile-controls/stop-cobrowser"
  >
    Stop co-browsing
  </button>
  } @if (isSecondaryStreamStopAvailable()) {
  <button
    class="tile-tool-light"
    avButton
    [attr.aria-label]="'Stop stream' | translate"
    ofType="stroked"
    size="xxs"
    [themable]="false"
    (click)="remoteStreamStopRequest()"
    translate
    data-tid="tile-controls/stop-stream"
  >
    Close camera
  </button>
  }
</div>
} @if (isMenuOpen()) {
<av-card #menu class="tile-controls-menu" [popup]="true" [hAlign]="hAlign" [vAlign]="vAlign()">
  <av-card-body size="xs" class="tile-controls-menu-body">
    <av-menu>
      @if (!isWhisper) { @if (isFileTransferAvailable) {
      <av-menu-item
        tabindex="0"
        icon="upload"
        class="tile-control-file"
        data-tid="tile-controls/send-file"
        title="{{ 'Send a file' | translate }}"
      >
        <span translate>Send a file</span>
        <input
          name="file-transfer"
          #fileInput
          [attr.accept]="allowedFileTypes()"
          tabindex="-1"
          (change)="fileAdded($event)"
          type="file"
        />
      </av-menu-item>
      } @if (isLaserAvailable) { @if (!isLaserActive) {
      <av-menu-item
        tabindex="0"
        icon="laser"
        [disabled]="isLaserDisabled()"
        (select)="togglePointer()"
        data-tid="tile-controls/start-at-pointer"
        title="{{ 'Laser pointer' | translate }}"
      >
        <span translate>Laser pointer</span>
      </av-menu-item>
      } @if (isLaserActive) {
      <av-menu-item
        tabindex="0"
        icon="laser"
        color="danger"
        (select)="togglePointer()"
        data-tid="tile-controls/stop-ar-pointer"
        title="{{ 'Stop AR pointer' | translate }}"
      >
        <span translate>Stop AR pointer</span>
      </av-menu-item>
      } } @if (isCobrowseAvailable) { @if (!isCobrowseActive) {
      <av-menu-item
        tabindex="0"
        icon="cobrowse"
        [disabled]="isCobrowseDisabled()"
        (select)="cobrowseRequest()"
        title="{{ 'Start co-browsing' | translate }}"
        data-tid="tile-controls/start-cobrowser"
      >
        {{ "Start co-browsing" | translate }}
      </av-menu-item>
      } @if (isCobrowseActive) {
      <av-menu-item
        tabindex="0"
        icon="cobrowse"
        [disabled]="isCobrowseStopDisabled"
        color="danger"
        (select)="cobrowseTerminate()"
        title=" {{ 'Stop co-browsing' | translate }}"
        data-tid="tile-controls/stop-cobrowser"
      >
        {{ "Stop co-browsing" | translate }}
      </av-menu-item>
      } } @if (isSnapshotAvailable) { @if (!isSnapshotActive) {
      <av-menu-item
        tabindex="0"
        [disabled]="isSnapshotDisabled()"
        icon="camera"
        (select)="snapshotRequest()"
        data-tid="tile-controls/open-snapshots"
        title="{{ 'Take snapshots' | translate }}"
      >
        {{ "Take snapshots" | translate }}
      </av-menu-item>
      } @if (isSnapshotActive) {
      <av-menu-item
        tabindex="0"
        icon="camera"
        color="danger"
        (select)="snapshotTerminate()"
        data-tid="tile-controls/stop-snapshots"
        title="{{ 'Stop snapshots' | translate }}"
      >
        {{ "Stop snapshots" | translate }}
      </av-menu-item>
      } } @if (isDesktopCaptureAvailable) { @if (isDesktopCaptureActive()) {
      <av-menu-item
        tabindex="0"
        icon="screen-stop"
        color="danger"
        (select)="desktopCaptureTerminate()"
        data-tid="tile-controls/stop-customer-desktop-capture"
        title="{{ 'Stop desktop capture' | translate }}"
      >
        {{ "Stop desktop capture" | translate }}
      </av-menu-item>
      } @if (!isDesktopCaptureActive()) {
      <av-menu-item
        tabindex="0"
        icon="screen-in"
        (select)="desktopCaptureRequest()"
        [disabled]="isDesktopCaptureDisabled()"
        [loading]="isDesktopCaptureLoading()"
        data-tid="tile-controls/request-customer-desktop-capture"
        title="{{ 'Capture desktop' | translate }}"
      >
        {{ "Capture desktop" | translate }}
      </av-menu-item>
      } } @if (isVisionAvailable) {
      <av-menu-item
        tabindex="0"
        icon="prompt"
        (select)="visionRequest()"
        data-tid="tile-controls/request-vision"
        title="{{ 'Vision' | translate }}"
      >
        {{ "Vision" | translate }}
      </av-menu-item>
      } @if (isFullScreenRequestAvailable) {
      <av-menu-item
        tabindex="0"
        icon="expand"
        [info]="isFullScreenDisabled ? 'Device does not support it' : ''"
        [disabled]="isFullScreenDisabled"
        (select)="fullscreenRequest()"
        data-tid="tile-controls/request-fullscreen"
        title="{{ 'Request full-screen' | translate }}"
      >
        {{ "Request full-screen" | translate }}
      </av-menu-item>
      } @if (isPinAvailable()) { @if (!isPinned()) {
      <av-menu-item
        tabindex="0"
        icon="pin"
        (select)="togglePin()"
        [disabled]="isPinDisabled()"
        data-tid="tile-controls/pin-tile"
        title="{{ 'Pin participant' | translate }}"
      >
        {{ "Pin participant" | translate }}
      </av-menu-item>
      } @if (isPinned()) {
      <av-menu-item
        tabindex="0"
        icon="pin"
        color="danger"
        (select)="togglePin()"
        [disabled]="isCobrowseActive || isSnapshotActive || isLaserActive || isScreenShareActive"
        data-tid="tile-controls/unpin-tile"
        title="{{ 'Unpin participant' | translate }}"
      >
        {{ "Unpin participant" | translate }}
      </av-menu-item>
      } } @if (isSecondaryDeviceAvailable()) {
      <av-menu-item type="separator"></av-menu-item>
      <av-menu-item type="header">{{
        "Other cameras" | translate
      }}</av-menu-item>
      @for (device of cameraDevices(); track device) {
      <av-menu-item
        icon="cam"
        [title]="device.label"
        [loading]="cameraDeviceLoading() === device.deviceId"
        (select)="remoteStreamStartRequest(device)"
        [disabled]="isSecondaryDeviceDisabled()"
      >
        {{ device.label }}
      </av-menu-item>
      } } @if (isControlActionEffectsSeparatorVisible) {
      <av-menu-item type="separator"></av-menu-item>
      } } @if (isPictureInPictureAvailable) { @if (!isPictureInPictureOn()) {
      <av-menu-item
        tabindex="0"
        class="menu-item-pop-out"
        icon="pop-out"
        [disabled]="isPictureInPictureDisabled()"
        (select)="pip()"
        data-tid="tile-controls/enable-pip"
        title="{{ 'Pop out' | translate }}"
      >
        {{ "Pop out" | translate }}
      </av-menu-item>
      } @if (isPictureInPictureOn()) {
      <av-menu-item
        tabindex="0"
        icon="pop-in"
        (select)="pip()"
        color="danger"
        data-tid="tile-controls/disable-pip"
        title="{{ 'Put back in' | translate }}"
      >
        {{ "Put back in" | translate }}
      </av-menu-item>
      } } @if (isFullscreenAvailable) {
      <av-menu-item
        tabindex="0"
        [icon]="isFullScreen() ? 'collapse' : 'expand'"
        [disabled]="isFullscreenDisabled()"
        (select)="toggleFullScreen()"
        data-tid="tile-controls/toggle-fullscreen"
      >
        @if (!isFullScreen()) {
        <span translate>Open in full screen</span>
        } @if (isFullScreen()) {
        <span translate>Exit full screen</span>
        }
      </av-menu-item>
      }
    </av-menu>
  </av-card-body>
  @if (isBitratePickerAvailable) { @if (isBitrateSeparatorVisible) {
  <av-menu-item type="separator"></av-menu-item>
  }
  <app-bitrate-picker
    role="menuitem"
    [stream]="stream()"
    (changed)="bitrateChanged()"
  ></app-bitrate-picker>
  }
</av-card>
}
